(function ($) {
	// On Dom Ready
	$(function () {
		var allExpanded = false;
		$('.collapsible-content .toggle-all').on('click', function (e) {
			e.preventDefault();
			if($('.collapsible-content .accordion-title').parent().hasClass('active')){
				$('.collapsible-content .accordion-title').parent().removeClass('active');
				$('.collapsible-content .accordion-title').next().slideUp();
			}

			if(!allExpanded){
				allExpanded = true;
				$(this).text('Collapse All');
				$('.collapsible-content .accordion-title').parent().toggleClass('active');
				$('.collapsible-content .accordion-title').next().slideToggle();
			}
			else{
				allExpanded = false;
				$(this).text('Expand All');
			}
		});

		$('.collapsible-content .accordion-title').on('click', function (e) {
			e.preventDefault();
			$(this).parent().toggleClass('active');
			$(this).next().slideToggle();
		});
	});
})(jQuery);
